import { TASK_HELPER_REMINDER_LEAD_MINUTES } from '../constants/index.js';
export const resolveHelperReminderMinutesBefore = (remindHelperBeforeDue) => remindHelperBeforeDue ? TASK_HELPER_REMINDER_LEAD_MINUTES : 0;
export const isHelperReminderEnabled = (helperReminderMinutesBefore) => helperReminderMinutesBefore > 0;
//# sourceMappingURL=taskHelperReminder.js.map